// Fixed pixel widths for the duplicate table columns. The address column has no fixed width so it
// fills the remaining space (the table uses a fixed layout, see ClientDuplicateWarning.styles.ts).
export const ClientDuplicateTableColumnWidth = {
  firstName: 180,
  lastName: 200,
  birthday: 140,
  caseNumber: 140,
  chevron: 48,
};
